import { IPost } from '../lib/types';
import {
  CATEGORY_SLUG,
  CLAIM_TAG_ARTICLES,
  CARTAX_TAG_ARTICLES,
  POST_V2_CATEGORY,
  POST_V2_TAG,
} from '../lib/constant';
import { parseCategories } from './parseCategories';

type TAGNAME_TYPE = 'claim' | 'cartax';

export const isBengkelPost = (post: IPost) => {
  try {
    return CATEGORY_SLUG.BENGKEL === parseCategories.getSlug(post.categories);
  } catch (e) {
    return false;
  }
};

export const hasPostTag = (tagName: TAGNAME_TYPE, post: IPost) => {
  try {
    if (post?.tags?.nodes?.length > 0) {
      if (tagName === 'claim')
        return post.tags.nodes.some((tag) => CLAIM_TAG_ARTICLES.includes(tag.slug));
      if (tagName === 'cartax')
        return post.tags.nodes.some((tag) => CARTAX_TAG_ARTICLES.includes(tag.slug));
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const isV2Post = (post: IPost) => {
  try {
    return isV2Category(post) || isV2Tag(post);
  } catch (e) {
    return false;
  }
};

export const isV2Category = (post: IPost) => {
  try {
    return POST_V2_CATEGORY.includes(parseCategories.getSlug(post.categories));
  } catch (e) {
    return false;
  }
};

export const isV2Tag = (post: IPost) => {
  try {
    if (post?.tags?.nodes?.length > 0) {
      return post.tags.nodes.some((tag) => POST_V2_TAG.includes(tag.slug));
    }
  } catch (e) {
    return false;
  }
};
